import { TestLeftMenu } from '../../../test/providers/test-provider';
import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { User } from "../../../common/models/user";
import { Organization } from "../../../common/models/organization";
import { MatListItem, MatListModule } from "@angular/material/list";
import { NgForOf, NgIf } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule } from "@ngx-translate/core";
import { MatLineModule } from "@angular/material/core";
import { RouterModule } from "@angular/router";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { DefaultPipe } from "../../../common/pipes/default";

@Component({
  selector: 'app-mobile-test-side-menu',
  providers: [],
  styleUrls: ['./mobile.side-menu.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    MatLineModule,
    RouterModule,
    AppDatePipe,
    DefaultPipe
  ],
  templateUrl: './mobile.side-menu.html'
})
export class MobileTestSideMenuComponent implements OnInit, OnChanges, OnDestroy {
    public isLoading = true;

    @Input()
    public tests: TestLeftMenu[] = [];

    @Input()
    public activeTestId : number | undefined;

    @Input()
    public athleteUser: User = {} as User;

    @Input()
    public organization: Organization = {} as Organization;

  constructor(private cd: ChangeDetectorRef) { }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['tests']) {
        this.cd.detectChanges(); // Force change detection
      }

    }

    public ngOnInit(): void {
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('tests');
    }

    public ngOnDestroy(): void {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('tests');
    }
}
